import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import enUS from 'ant-design-vue/es/locale/en_US'
import i18n, { LOCALE_STORAGE_KEY, type AppLocale } from '@/i18n'

export const useLocaleStore = defineStore('locale', () => {
  const locale = ref<AppLocale>(i18n.global.locale.value as AppLocale)

  const antdLocale = computed(() => (locale.value === 'zh-CN' ? zhCN : enUS))

  function setLocale(next: AppLocale) {
    locale.value = next
    i18n.global.locale.value = next
    localStorage.setItem(LOCALE_STORAGE_KEY, next)
    document.documentElement.lang = next === 'zh-CN' ? 'zh-CN' : 'en'
  }

  function toggleLocale() {
    setLocale(locale.value === 'zh-CN' ? 'en-US' : 'zh-CN')
  }

  document.documentElement.lang = locale.value === 'zh-CN' ? 'zh-CN' : 'en'

  return { locale, antdLocale, setLocale, toggleLocale }
})
